import { AxlClipboard } from "@axl/accel-framework/utils";
import qs from "qs";
import { NavigateFunction, NavigateOptions } from "react-router";

export type AppNavigatorOptions = {
    includeOrigin?: boolean;
}

export class AppNavigatorLink {
    constructor(public relativeUrl: string,
        private navigateFn: NavigateFunction) {
    }

    get originUrl() {
        return `${window.location.origin}${this.relativeUrl}`;
    }

    async copyToClipboard(origin = false) {
        const url = origin ? this.originUrl : this.relativeUrl;
        return AxlClipboard.copyText(url);
    }

    navigate(options?: NavigateOptions) {
        this.navigateFn(this.relativeUrl, options);
    }
}

export default class AppNavigator {
    origin = window.location.origin;

    constructor(private navigateFn: NavigateFunction) {
    }

    getUrl(url: string, options: AppNavigatorOptions = { includeOrigin: false }) {
        if (options.includeOrigin)
            return `${this.origin}${url}`;
        return url;
    }

    getNavigateLink(url: string) {
        return new AppNavigatorLink(url, this.navigateFn);
    }

    learn = {
        getLearnUrl: (id: string, tab?: string, opts?: {
            commentId?: string,
            taskId?: string,
        }) => {
            tab = tab ? `/${tab}` : '';
            const args = opts && qs.stringify(opts);
            return this.getNavigateLink(`/learn/${id}${tab}${args ? `?${args}` : ''}`);
        }
    }

    library = {
        getLibraryUrl: (id: string, stepId?: string) => {
            return this.getNavigateLink(`/library/${id}/${stepId ?? ''}`);
        }
    }
}
